import { render, staticRenderFns } from "./PresentingComplaintHistoryCard.vue?vue&type=template&id=94cc2ac6&scoped=true&"
import script from "./PresentingComplaintHistoryCard.vue?vue&type=script&lang=js&"
export * from "./PresentingComplaintHistoryCard.vue?vue&type=script&lang=js&"
import style0 from "./PresentingComplaintHistoryCard.vue?vue&type=style&index=0&id=94cc2ac6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94cc2ac6",
  null
  
)

export default component.exports